import React, { ReactNode } from 'react';

// Material
import { Grid } from '@material-ui/core';

// Style
import './Footer.scss';

interface Props {
    children: ReactNode,
    className?: string
}

const Footer: React.FC<Props> = ({ children, className = '' }) => (
    <Grid
        className={`ui-Footer-component${className ? ` ${className}` : ''}`}
    >
        {children}
    </Grid>
);

export default Footer;
